module.exports = __webpack_public_path__ + "static/media/byob-white.806d9289.svg";